import { jsx } from "react/jsx-runtime";
import { Text } from "../../Text/Text.mjs";
const getCharacterLimitStatus = ({
  characterLimit,
  value
}) => {
  const inputLength = String(value).length;
  if (inputLength < Math.ceil(characterLimit * 0.7 / 10) * 10) {
    return null;
  }
  const diff = characterLimit - inputLength;
  const valid = diff >= 0;
  return /* @__PURE__ */ jsx(Text, { size: "small", tone: valid ? "secondary" : "critical", children: diff });
};
export {
  getCharacterLimitStatus
};
